@if (selectedFiles().length) {
  <div class="selected-files">
    <div class="selected-files-items">
      @for (file of selectedFiles(); track $index) {
        <app-delayed-file-upload-item
          [delayedFileUploadItem]="{
            index: $index,
            fileName: file.name
          }"
          (deleteFile)="deleteFile($event)"
        />
      }
    </div>
  </div>
}

@if (!selectedFiles().length || multiple()) {
  <div
    class="upload-dropzone"
    [class]="getClasses"
    (drop)="handleFileDropped($event)"
    (dragover)="handleDragOver($event)"
    (dragleave)="handleDragLeave($event)"
  >
    <p>Перетащите файлы</p>
    <div class="selected-files-buttons">
      <button
        mat-icon-button
        tabindex="-1"
        class="button-icon"
        [matTooltip]="getTooltip()"
        (click)="togglePasteMode()"
      >
        <mat-icon>{{ getIcon }}</mat-icon>
      </button>
      <button
        mat-icon-button
        tabindex="-1"
        class="button-icon"
        matTooltip="Выбрать файлы"
        (click)="fileInput.click()"
      >
        <mat-icon>attach_file</mat-icon>
      </button>
    </div>
    <input
      #fileInput
      type="file"
      hidden
      [multiple]="multiple()"
      [accept]="getAcceptString()"
      (change)="handleFileSelected($event)"
    />
  </div>
}
